import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import { convertDate } from "../../../utils";
import { enteredEmployeeCodeAdminContext } from "../../../context/Admin/EnteredEmployeeCodeAdminContext/EnteredEmployeeCodeAdminContext";

const EnteredEmployeeCodeAdmin = () => {
  const {
    codes,
    search,
    setSearch,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    handleGetEnteredEmployeeCode,
  } = useContext(enteredEmployeeCodeAdminContext);

  useEffect(() => {
    handleGetEnteredEmployeeCode();
  }, [pageNumber, limit]);

  return (
    <>
      <SiteTitle title="کدهای پرسنلی وارد شده" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "کدهای پرسنلی وارد شده", type: "a" },
        ]}
        title="لیست کدهای پرسنلی وارد شده"
      />

      <CardLayout>
        <form
          className="input-group mb-3"
          onSubmit={handleGetEnteredEmployeeCode}
        >
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو ..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>
        {isEmpty(codes) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark text-center">
                <tr>
                  <th>#</th>
                  <th>نام و نام خانوادگی</th>
                  <th>نام کاربری</th>
                  <th>شماره موبایل</th>
                  <th>تاریخ ایجاد</th>
                  <th>کد پرسنلی وارد شده</th>
                  <th>کد سازمانی وارد شده</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {codes.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      {_item?.client?.first_name} {_item?.client?.last_name}
                    </td>
                    <td>{_item?.client?.username}</td>
                    <td>{_item?.client?.mobile}</td>
                    <td>{convertDate(_item?.created)}</td>
                    <td>{_item?.employee_entered_code}</td>
                    <td>{_item?.employer_entered_code}</td>
                    <td />
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>
    </>
  );
};

export default EnteredEmployeeCodeAdmin;
